module.exports = __webpack_public_path__ + "img/workspace-clip-maker.15530c87.png";